import Vue from 'vue'

export const mutations = {
  authRequest (state) {
    Vue.set(state, 'status', 'loading')
  },

  authSuccess (state, token) {
    Vue.set(state, 'status', 'success')
    Vue.set(state, 'token', token)
  },

  authLogout (state) {
    Vue.set(state, 'status', '')
    Vue.set(state, 'token', '')
  }
}
